import { useEffect, useState } from 'react';
const useTimer = (targetDate: Date) => {
    const counterDate = new Date(targetDate).getTime();
    const [counter, setCounter] = useState<number>(new Date().getTime() - counterDate);

    useEffect(() => {
        setCounter(new Date().getTime() - counterDate);

        const interval = setInterval(() => {
            setCounter(new Date().getTime() - counterDate);
        }, 1000);

        return () => clearInterval(interval);
    }, [counterDate]);

    return Math.floor((counter % (1000 * 60)) / 1000);
};
export default useTimer;
